import moment from 'moment';

export function getObjectDeltas(
  oldObj: any,
  newObj: any,
  skipList: string[],
  contextName: string = null
): any {
  const data = {};

  if (oldObj === null && newObj === null) {
    return data;
  } else if (oldObj === null && typeof newObj === 'object') {
    // object was created, return everything for new
    Object.keys(newObj).forEach(n => {
      const newVal = newObj[n];
      if (
        skipList.indexOf(n) === -1 &&
        newVal !== null &&
        newVal !== undefined &&
        newVal.toString().trim() !== ''
      ) {
        if (newVal instanceof Date) {
          data[n] = `{ "oldVal": "", "newVal": "${newVal.toLocaleString()}" }`;
        } else {
          data[n] = `{ "oldVal": "", "newVal": "${newVal}" }`;
        }
      }
    });
  } else if (newObj === null && typeof oldObj === 'object') {
    // object was deleted, return everything for old
    Object.keys(oldObj).forEach(n => {
      const oldVal = oldObj[n];
      if (
        skipList.indexOf(n) === -1 &&
        oldVal !== null &&
        oldVal !== undefined &&
        oldVal.toString().trim() !== ''
      ) {
        if (oldVal instanceof Date) {
          data[n] = `{ "oldVal": "${oldVal.toLocaleString()}", "newVal": "" }`;
        } else {
          data[n] = `{ "oldVal": "${oldVal}", "newVal": "" }`;
        }
      }
    });
  } else if (typeof oldObj === 'object' && typeof newObj === 'object') {
    // compare both objects and return any properties that have changed
    Object.keys(newObj).forEach(n => {
      // convert null or undefined to empty string
      const newVal = newObj[n] !== null && newObj[n] !== undefined ? newObj[n] : '';
      const oldVal = oldObj[n] !== null && oldObj[n] !== undefined ? oldObj[n] : '';

      // check for ISO date format or date object
      if (
        /^\d{4}-([0]\d|1[0-2])-([0-2]\d|3[01])/.test(newVal) ||
        newVal instanceof Date ||
        /^\d{4}-([0]\d|1[0-2])-([0-2]\d|3[01])/.test(oldVal) ||
        oldVal instanceof Date
      ) {
        // convert both to utc to avoid time offsets
        const nDate = moment.utc(newVal);
        const oDate = moment.utc(oldVal);
        const oldLocal = oDate.isValid() ? new Date(oldVal).toLocaleString() : '';
        const newLocal = nDate.isValid() ? new Date(newVal).toLocaleString() : '';

        if (!nDate.isSame(oDate) && skipList.indexOf(n) === -1 && oldLocal !== newLocal) {
          data[n] = `{ "oldVal": "${oldLocal}", "newVal": "${newLocal}" }`;
        }
      } else if (
        newVal.toString().trim() != oldVal.toString().trim() &&
        skipList.indexOf(n) === -1
      ) {
        // make sure things like 5.00 vs 5 do not show as a change
        if (
          /^(\d*\.)?\d+$/.test(newVal) &&
          /^(\d*\.)?\d+$/.test(oldVal) &&
          parseFloat(newVal) === parseFloat(oldVal)
        ) {
          // numbers are equal. do nothing
        } else {
          data[n] = `{ "oldVal": "${oldVal}", "newVal": "${newVal}" }`;
        }
      }
    });
  }

  // US 5648
  if (contextName) {
    const d = {};
    Object.keys(data).forEach(x => {
      d[`${contextName} > ${x}`] = data[x];
    });
    return d;
  } else {
    return data;
  }
}
